const config = {
    googleSheetsUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT2ol9QWiw26yK6FFSJ-WiRl1WDw8cBJiET4M81YPEgbIQoq2Fk3RnL_dRutLRsEDymbqOAo3K5Osr4/pub?gid=0&single=true',
    appOwnerPhone: '+972543007218',
    version: 'beta-0.0.28'
}

export default config;